module.exports = __webpack_public_path__ + "ad1122197f567f156fb929082bc95df4.png";


//////////////////
// WEBPACK FOOTER
// ./res/images/backgrounds/popups/classica.png
// module id = 865
// module chunks = 0